import RentListOverview from './rent_list_overview'
import connect from './connect'

export default connect(RentListOverview)
